(() => {
  angular
    .module('complianceFrameworkApp.socialMediaCompliance')
    .controller('RssFeedsController', RssFeedsController);

  /* ngInject */
  function RssFeedsController($stateParams, brandMonitorService, rssFeedService, sessionService) {
    const vm = this;

    vm.brandMonitor = {};
    vm.brandMonitorId = $stateParams.brand_monitor_id;
    vm.rssFeeds = [];

    activate();

    function activate() {
      getBrandMonitor();
      getRssFeeds();
    }

    function getBrandMonitor() {
      brandMonitorService(sessionService.getAuthToken()).get({ id: vm.brandMonitorId }, response => vm.brandMonitor = response);
    }

    function getRssFeeds() {
      rssFeedService(sessionService.getAuthToken()).query({ brand_monitor_id: vm.brandMonitorId }, response => vm.rssFeeds = response);
    }
  }
})();
